import styled from "styled-components";

export const ContainerModalSubirOrden = styled.div`
  max-width: 400px;
  margin: auto;
  height: max-content;
  border-radius: 8px;

  .cruz {
    right: 16px;
    top: 10px;
  }
  @media (max-height: 700px) {
    height: max-content;
    display: flex;
  }
  .image-current {
    height: 280px;
    width: 277px;
    border-radius: 8px;
    object-fit: contain;

  }
  @media (max-height: 700px){
    .image-current {
      height: 200px !important;
      width: 200px !important;
    }
  }
  .success {
    background: var(--color-broccoli);
  }
  .danger {
    background-color: var(--color-danger);
  }
`;
export const TopModalSubirOrden = styled.div`
  height: 68px;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    color: var(--color-white);
    font-size: 18px;
    font-weight: bold;
  }

  .cruz {
    margin-top: 4px;
  }
`;

export const BodyModalSubirOrden = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  width: 90%;
  margin: auto;
  height: calc(100% - 68px);
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 300px;
    position: relative;
    cursor: pointer;
    .autocheckin-absolute {
      cursor: pointer;
      width: 100%;
      height: 100%;
      opacity: 0;
      position: absolute;
    }
    span {
      text-align: center;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 150%;
    }
  }
  .contianer-btn {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  span {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
  }
  .text-center {
    text-align: center;
  }
`;


